import React, {useCallback} from "react";
import {MobileNumber, RegistrationFields} from "../../../../containers/RegistrationLoginPage/types";
import {Field} from "react-final-form";
import TextField from "../../../HTMLEntities/Textfield";
import {
    composeValidators,
    minLengthValidate,
    regRequiredValidate,
    maxLengthValidate,
    startingDigitValidation,
    regNumberValidate,
    checkMobileAvailable,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {useFormState} from "react-final-form";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {isUserLoggedIn} from "../../../../utils/utils";

interface MobileNumberInterface {
    configuration: MobileNumber;
    mobileOnClickHandler?(sdkFlag: boolean): void;
    isCheckMobileExist?: boolean;
}
const MobileNumberField: React.FC<MobileNumberInterface> = ({
    configuration,
    mobileOnClickHandler,
    isCheckMobileExist = false,
}: MobileNumberInterface) => {
    const {fieldName, editable, selectedValue} = configuration;
    const isLoggedIn = useSelector((state: RootStore) => state.layout.isUserLoggedIn ?? false);

    const {values} = useFormState<RegistrationFields>({
        subscription: {values: true},
    });

    let minLength: number, maxLength: number;
    // eslint-disable-next-line @typescript-eslint/ban-types
    const numberValidation: Function[] = [
        regRequiredValidate("Mobile number is mandatory"),
        regNumberValidate("Invalid mobile number"),
    ];

    if (values.countryCode?.id === 2) {
        numberValidation.push(startingDigitValidation([6, 7, 8, 9]));
        minLength = 10;
        maxLength = 10;
    } else {
        minLength = 6;
        maxLength = 20;
    }

    numberValidation.push(
        minLengthValidate(minLength, `Invalid mobile number`),
        maxLengthValidate(maxLength, `Invalid mobile number`),
    );

    if (isCheckMobileExist) {
        numberValidation.push(checkMobileAvailable(values.countryCode?.code));
    }

    const mobileClickHandler = useCallback(() => {
        const userLoggedIn = isClientEnv ? isUserLoggedIn() : isLoggedIn;
        if (!userLoggedIn && mobileOnClickHandler) mobileOnClickHandler(true);
    }, [isLoggedIn, mobileOnClickHandler]);

    return (
        <Field<string>
            name={fieldName}
            {...(editable
                ? {
                      validate: composeValidators(...numberValidation),
                  }
                : {})}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
        >
            {(props) => {
                return (
                    <TextField
                        placeholder="Mobile Number"
                        type="tel"
                        commonFieldStyle={{
                            mobile: {width: "55%"},
                            laptop: {width: "55%"},
                        }}
                        minLength={minLength}
                        maxLength={maxLength}
                        autoComplete="off"
                        initialValue={props?.input?.value ?? ""}
                        isFocused={props?.meta?.active ?? false}
                        isFilled={props?.input?.value.length > 0}
                        error={errorHandler(props?.meta)}
                        isTouched={props?.meta?.touched}
                        inputRFF={props?.input}
                        isDisabled={!editable}
                        onClick={mobileClickHandler}
                    />
                );
            }}
        </Field>
    );
};
export default MobileNumberField;
